<template>
    <div>
        <Header />
            <div class="container pt-5 mt-3">
                <div class="d-flex flex-wrap py-5" v-if="myCourseData.length > 0">
                    <h2 class="text-center text-md-left w-100 pb-md-4 my-courses-text"><span>My Courses</span></h2>
                    <CourseCard class="col-lg-4 col-md-6 col-12 my-md-3 my-2 p-1" :myCourse="mycourse" :key="mycoursekey" v-for="(mycourse,mycoursekey) in myCourseData"/>
                    <!-- <CourseCard class="col-lg-4 col-md-6 col-12 my-md-3 my-2 p-1" :myCourse="1" />
                    <CourseCard class="col-lg-4 col-md-6 col-12 my-md-3 my-2 p-1" :myCourse="1" />
                    <CourseCard class="col-lg-4 col-md-6 col-12 my-md-3 my-2 p-1" :myCourse="1" /> -->
                </div>
                <div class="d-flex flex-wrap py-5" v-else>
                    <h2 class="text-center text-md-left w-100 pb-md-4 my-courses-text"><span>No Course Assigned</span></h2>
                    <a class="btn btn-primary" href="https://avishkaar.cc/shop">Explore Our Course Offerings</a>
                </div>
            </div>
        <Footer />
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import Header from "@/components/header.vue";
    import Footer from "@/components/footer.vue";
    const CourseCard = () => import('@/components/microComponents/courseCard');
export default {
    name: "Review",
    components: {
        Header,
        Footer,
        CourseCard
    },
    methods: {
        ...mapActions(["fetchMyCourseData"]),
    },
    computed: {
        ...mapGetters({myCourseData:"getMainCoursedata"}),
    },
    created(){
        if(this.$cookies.get('userAccess') !== null){
            this.fetchMyCourseData()
        }
    }
}
</script>

<style scoped>
    .my-courses-text {
        color: #303030;
        font-size: 32px !important;
    }
    @media screen and (max-width: 430px) {
        .my-courses_text > span {
            font-size: 30px !important;
        }
    }
</style>